import { CompGroupSelected } from 'pages/Valuations/components/CompGroups/components/common/types';
import { PublicComp } from 'pages/ValuationsAllocation/types';

const patchCompsWithLatestVersionLink = (
  results: PublicComp[],
  useLatestVersion: boolean,
  compGroupSelected: CompGroupSelected
) =>
  results.map(item => {
    const gpcItem = {
      ...item,
    };
    if (useLatestVersion) {
      gpcItem.comp_group_id = compGroupSelected.id.toString();
      gpcItem.comp_group_name = compGroupSelected.name;
    }
    return {
      gpc: gpcItem,
      valid_gpc_results: true,
    };
  });

export default patchCompsWithLatestVersionLink;
